import markets from '@prisjakt/web-app-config/markets';

export const isActiveMarket = (countryCode: string) => {
  return Boolean(
    Object.keys(markets)
      .filter(code => markets[code].active)
      .find(code => code === countryCode)
  );
};
